import React from 'react'
import PropTypes from 'prop-types'
import invariant from 'tiny-invariant'
import loadable from '@loadable/component'
import Fold from 'js/components/Fold'

const WhatIsLifesum = loadable(() =>
  import('js/components/WhatIsLifesum/WhatIsLifesum'),
)
const Testimonials = loadable(() =>
  import('js/components/Testimonials/Testimonials'),
)
const RecipesTeaser = loadable(() =>
  import('js/components/RecipesTeaser/RecipesTeaser'),
)

const PlanTest = loadable(() => import('../../components/PlanQuiz/PlanQuiz'))
const BMICalculator = loadable(() =>
  import('../../components/BMICalculator/BMICalculator'),
)
const PremiumButton = loadable(() =>
  import('../../components/PremiumButton/PremiumButton'),
)
const CalorieBurnCalculator = loadable(() =>
  import('../../components/CalorieBurnCalculator/CalorieBurnCalculator'),
)
const CalorieIntakeCalculator = loadable(() =>
  import('../../components/CalorieIntakeCalculator/CalorieIntakeCalculator'),
)

const DatoCTA = loadable(() => import('js/components/DatoCTA/DatoCTA'))

const Awards = loadable(() => import('js/components/Awards'))

const KetoSteps = loadable(() => import('js/components/KetoSteps'))

const widgets = {
  WhatIsLifesum,
  RecipesTeaser,
  Testimonials,
  AppButton: DatoCTA,
  AppButtons: DatoCTA,
  PlanTest,
  BMICalculator,
  PremiumButton,
  CalorieBurnCalculator,
  CalorieIntakeCalculator,
  Fold,
  Awards,
  KetoSteps,
}

export default function WidgetBlock({ component, cta }) {
  const Element = widgets[component]
  invariant(Element, `No widget named: ${component}`)
  return (
    <div className="my-36 flex justify-center">
      {['AppButton', 'AppButtons'].includes(component) ? (
        <Element {...cta} />
      ) : (
        <Element />
      )}
    </div>
  )
}

WidgetBlock.propTypes = {
  component: PropTypes.string,
  cta: PropTypes.object,
}
